
import styled from "styled-components";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ReactComponent as Arrow } from "../../../../../assets/icons/arrow.svg";
import { ReactComponent as ArrowUp } from "../../../../../assets/icons/arrow_up.svg";
import { ReactComponent as ArrowDown } from "../../../../../assets/icons/arrow_down.svg";
import Icon from "../../../../../components/icon";
import { theme } from "../../../../../helpers/theme";

interface OfferTrailerProps {
    offer_id: string;
    order_id?: string;
    index?: number;
    value: number;
    setExpanded: (value: string) => void;
    expanded: string | false;
}

export const OfferTrailer = (
    {
        expanded,
        offer_id,
        index,
        value,
        setExpanded,
    }: OfferTrailerProps) => {

    const handleClick = (expanded: string | false, offer_id: string) => {

        expanded === offer_id ? setExpanded(`${false}`) : setExpanded(offer_id);
    }

    return (
        <Container
            expanded={expanded}
            offer_id={offer_id}
            onClick={() => handleClick(expanded, offer_id)}>
            <Section>
                <ButtonAction>
                    <Icon
                        width="20px"
                        height="20px"
                        noPadding
                        icon={<ExpandMoreIcon
                            sx={{
                                transition: `all 0.75s 0.25s`,
                                rotate: `${(expanded === offer_id) ? "180deg" : "0deg"}`,
                                color: `${theme.colors.gray01_secondaryText}`,
                                '&:hover': {
                                    color: `${theme.colors.black_primaryText}`
                                },

                            }} />}
                    // icon={
                    //     (expanded === offer_id ?
                    //         <ArrowUp style={{
                    //             "transition": "all 0.75s 0.25s",
                    //             "transform": "rotate(0deg)"
                    //         }} />
                    //         : <ArrowDown />
                    //     )}
                    />
                </ButtonAction>
                <OfferNumber>{`Oferta nr: ${offer_id}`} </OfferNumber>
            </Section>
            <OfferValue> 
                {
                value!==0
                ?`${value.toFixed(2)} zł`
                : null
                }
                </OfferValue>
        </Container >

    );
};
const Container = styled.div<{
    expanded: string | false;
    offer_id: string;
}>`
background-color: ${theme.colors.gray05_input};
margin-bottom: 16px;
cursor: pointer;
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
box-sizing: border-box;
min-height: 56px;
//border: 1px solid ${theme.colors.gray01_secondaryText};

padding 20px 16px;
//color: ${(props: any) => (props.expanded === props.offer_id ? "green" : "red")};
${(props: any) => (props.expanded === props.offer_id
        ?
        `
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        margin-bottom:-36px;
        div{
            color:${theme.colors.blue01_active};
           } 
        `

        :
        `
        border-radius: 8px;
        :hover {
            border: 1px solid ${theme.colors.gray05_input};
           div{
            color:${theme.colors.blue01_active};
           } 
          }
        `
    )

    }
`;
const OfferNumber = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
padding-right:8px;

`
const OfferValue = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
`;
const ButtonAction = styled.div`
    padding-right: 20px; `;
const Section = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center; `;


